const now = new Date()

export const myServiceList = [
  {
    id: 0,
    title: 'House Cleaning',
    allDay: true,
    start: new Date(2020, 3, 0),
    end: new Date(2020, 3, 1),
  },
  {
    id: 1,
    title: 'Floor Cleaning',
    start: new Date(2020, 3, 7),
    end: new Date(2020, 3, 10),
  },

  {
    id: 2,
    title: 'Kitchen Cleaning',
    start: new Date(2020, 2, 13, 0, 0, 0),
    end: new Date(2020, 2, 20, 0, 0, 0),
  },

  {
    id: 3,
    title: 'House Cleaning',
    start: new Date(2020, 10, 6, 0, 0, 0),
    end: new Date(2020, 10, 13, 0, 0, 0),
  },

  {
    id: 4,
    title: 'House Cleaning',
    start: new Date(2020, 3, 9, 0, 0, 0),
    end: new Date(2020, 3, 10, 0, 0, 0),
  },
  {
    id: 5,
    title: 'House Cleaning',
    start: new Date(2020, 3, 11),
    end: new Date(2020, 3, 13),
    // desc: 'Big conference for important people',
  },
  {
    id: 6,
    title: 'House Cleaning',
    start: new Date(2020, 3, 12, 10, 30, 0, 0),
    end: new Date(2020, 3, 12, 12, 30, 0, 0),
    // desc: 'Pre-meeting meeting, to prepare for the meeting',
  },
  {
    id: 7,
    title: 'House Cleaning',
    start: new Date(2020, 3, 12, 12, 0, 0, 0),
    end: new Date(2020, 3, 12, 13, 0, 0, 0),
    // desc: 'Power lunch',
  },
  {
    id: 8,
    title: 'House Cleaning',
    start: new Date(2020, 3, 12, 14, 0, 0, 0),
    end: new Date(2020, 3, 12, 15, 0, 0, 0),
  },
  {
    id: 9,
    title: 'Floor Cleaning',
    start: new Date(2020, 3, 12, 17, 0, 0, 0),
    end: new Date(2020, 3, 12, 17, 30, 0, 0),
    // desc: 'Most important meal of the day',
  },
  {
    id: 10,
    title: 'House Cleaning',
    start: new Date(2020, 3, 12, 20, 0, 0, 0),
    end: new Date(2020, 3, 12, 21, 0, 0, 0),
  },
  {
    id: 11,
    title: 'House Cleaning',
    start: new Date(2020, 3, 13, 7, 0, 0),
    end: new Date(2020, 3, 13, 10, 30, 0),
  },
  {
    id: 12,
    title: 'House Cleaning',
    start: new Date(2020, 3, 17, 19, 30, 0),
    end: new Date(2020, 3, 18, 2, 0, 0),
  },
  {
    id: 12.5,
    title: 'Kitchen Cleaning',
    start: new Date(2020, 3, 17, 19, 30, 0),
    end: new Date(2020, 3, 17, 23, 30, 0),
  },
  {
    id: 13,
    title: 'House Cleaning',
    start: new Date(2020, 3, 20, 19, 30, 0),
    end: new Date(2020, 3, 22, 2, 0, 0),
  },
  {
    id: 14,
    title: 'Today',
    start: new Date(new Date().setHours(new Date().getHours() - 3)),
    end: new Date(new Date().setHours(new Date().getHours() + 3)),
  },
  {
    id: 15,
    title: 'House Cleaning',
    start: now,
    end: now,
  },
]